import styled, { css } from 'styled-components';
const baseButtonCss = css `
  background: none;
  border: 0;
  box-sizing: border-box;
  font-family: 'Circular Std';
  color: inherit;
  line-height: normal;
  overflow: visible;
  padding: 0px;
  user-select: none; /* for button */
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-appearance: button; /* used to fallback on native UI */
  cursor: pointer;

  &:disabled {
    cursor: inherit;
  }
  &::-moz-focus-inner {
    border: 0;
    padding: 0;
  }
`;
export const NoStyleButton = styled.button `
  ${baseButtonCss}
`;
//# sourceMappingURL=button.js.map